import { NarrowPageWrapper } from 'components/narrow-page-wrapper/NarrowPageWrapper';
import { PageRootContainer } from 'components/page-root-container/PageRootContainer';
import Debug from 'features/debug/Debug';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';

const DebugPage = () => {
  useRequireRoles(ROLE_TYPE.ADMIN, ROLE_TYPE.DEBUG);

  return (
    <>
      <PageRootContainer>
        <NarrowPageWrapper>
          <Debug />
        </NarrowPageWrapper>
      </PageRootContainer>
    </>
  );
};

export default DebugPage;
